import { render, staticRenderFns } from "./switchAccount.vue?vue&type=template&id=3faf2662&scoped=true"
import script from "./switchAccount.vue?vue&type=script&lang=js"
export * from "./switchAccount.vue?vue&type=script&lang=js"
import style0 from "./switchAccount.vue?vue&type=style&index=0&id=3faf2662&prod&lang=css"
import style1 from "./switchAccount.vue?vue&type=style&index=1&id=3faf2662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf2662",
  null
  
)

export default component.exports